import { FC } from "react";
import styles from './index.module.less';
import logo from '../../assets/logo2.svg';
import qrcode from '../../assets/code.png';
import { official, management } from "../../config";


const Index: FC = () => {
    const jump = (url) => {
        window.open(url);
    }
    return (
        <div className={styles.body}>
            <div style={{width: '1200px', display: 'flex', justifyContent: 'space-between'}}>

                <div className={styles.image}>
                    <img style={{height: '72px'}} src={logo} alt="" />
                </div>
                <div className={styles.middle}>
                    <div className={styles['middle-text']}>友情链接</div>
                    <div onClick={() => jump(official)} className={styles['middle-text']}>北京航空航天大学</div>
                    <div onClick={() => jump(management)} className={styles['middle-text']}>资产与实验室管理处</div>
                </div>
                <div className={styles.right}>
                    <div className={styles.contact}>联系我们</div>
                    <div className={styles.code}>
                        <div>
                            <img src={qrcode} alt="" />
                        </div>
                        <div className={styles['code-right']}>
                            <div>
                                资产与实验室管理处 联系人：赵浩 15011352638
                            </div>
                            <div>
                                基理科技&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;实验室服务电话：13207593619
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div className={styles.border}></div>
            <div className={styles.copyright}>
                {new Date().getFullYear()} 北京航空航天大学资产与实验室管理处 All Rights Reserved  技术支持：天津市基理科技有限公司
            </div>
        </div>
     );
}

export default Index;